import { fillCommandLineParams } from "@features/FxLauncherLoader/utils/helpers";
import { DEFAULT_LANG } from "./constants";
import { appStore } from "@/app/store/appStore";
import { basePath } from "@pages/PurchasePage/PurchasePage";
import { persistStore } from "@entities/StepFolder/store/persistStore";

/**
 * Функция получения локали
 *
 * @returns {LANGUAGES_TO_TEXT_ENUM}
 */
export function getUserDefaultLanguage() {
	let language = window.navigator?.language ?? DEFAULT_LANG;

	language = language.slice(0, 2).toLowerCase(); // получаем язык без учета региона

	return language;
}

export function openLinkPrepare(target?: string): WindowProxy | null {
	if (!appStore.getState().runningInLauncher) {
		if (target) {
			return window.open("", target);
		} else {
			return window.open("");
		}
	} else {
		return null;
	}
}

export function openLinkPrepareCancel(wnd?: WindowProxy | null) {
	if (wnd) {
		wnd.close();
	}
}

export function openLink(Link: string | null | undefined, wnd?: WindowProxy | null) {
	if (!Link) {
		console.log("No link provided");
		return;
	}
	const linkFilled = fillCommandLineParams(Link);
	if (appStore.getState().runningInLauncher) {
		FxApi.shellExecute(linkFilled, "");
	} else if (wnd) {
		wnd.location.href = linkFilled;
	} else {
		const w = window.open(linkFilled, "_blank");
		if (w === null) {
			window.location.href = linkFilled;
		}
	}
}

export function getLauncherScheme() {
	return (appStore.getState().gameConfig.PublicWebClientConfig.Launcher?.UrlScheme || "fxl-aw-dev") + ":";
}

export function generateLink(launcher: boolean, params: string, recallOauthState?: boolean) {
	const appCode  = appStore.getState().appCode;
	const uri = (recallOauthState ? persistStore.getState().stateAfterOauth?.location : null) || `${window.location.origin}${basePath}${appCode}`;
	const url = new URL(uri);

	// Split params into path, search, and hash parts
	const [fullPath, hashPart] = params.split('#');
	const [pathPart, searchPart] = fullPath.split('?');

	// Update pathname if pathPart exists
	if (pathPart && !pathPart.startsWith('?')) {
		// Ensure pathPart starts with '/' if it doesn't already
		url.pathname = pathPart.startsWith('/') ? pathPart : `${basePath}` + pathPart;
	}

	// Handle search params if they exist
	if (searchPart) {
		const newParams = new URLSearchParams(searchPart);
		newParams.forEach((value, key) => url.searchParams.set(key, value));
	}

	return `${launcher ? getLauncherScheme() : url.protocol}//${url.hostname}${url.port ? `:${url.port}` : ''}${url.pathname}${url.searchParams.toString() ? '?' + url.searchParams.toString() : ''}${hashPart ? '#' + hashPart : ''}`;
}
export function rememberLocationForPostOauth()
{
	const location = window.location.href;
	persistStore.getState().setStateAfterOauth({location});

	console.log(`Remembered location for post-oauth: ${location} for appCode: ${appStore.getState().appCode} runningInLauncher: ${appStore.getState().runningInLauncher} type:`)
}

export function getRedirect(type: string): string {
	return generateLink(
		false,
		`auth/api/${type}/${appStore.getState().runningInLauncher ? "launcher" : "web"}/${appStore.getState().appCode}`
	);
}

export function humanFileSize(bytesParam: number, si = true, dp = 1): string {
	let bytes = bytesParam;
	const thresh = 1024;

	if (Math.abs(bytes) < thresh) {
		return `${bytes} B`;
	}

	const units = si
		? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
		: ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
	let u = -1;
	const r = 10 ** dp;

	do {
		bytes /= thresh;
		u += 1;
	} while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

	return `${bytes.toFixed(dp)} ${units[u]}`;
}

export function closeApp() {
	try {
		FxApi.setWindowVisible(false).then(() => 'widow hidden before closing');
	}
	catch (e){
		console.log('Error hiding window:', e);
	}
	window.close();
}
